import styled from '@emotion/styled';
import { Card } from '../UI/UI';

const Container = styled(Card)`
  height: 100%;
  width: 100%;
`;

const Title = styled.h2`
  margin: 0 0 20px 0;
  font-size: 20px;
  line-height: 20px;
`;

const CellContainer = styled.div``;

export { Container, Title, CellContainer };
